import {type ProjectTemplate} from '../types.js'

const appTemplate: ProjectTemplate = {
  entry: './src/App.tsx',
  type: 'module',
  typescriptOnly: true,
}

export default appTemplate
